<template>
  <v-card elevation="0" class="rounded-xl transparent" id="tree">
    <v-treeview :items="categories" @update:open="renderTreeNode">
      <template slot="label" slot-scope="{ item }">
        <div v-if="item.kinescope_id">
          <v-list>
            <v-list-group
              v-for="p in [item].filter((i) => i.kinescope_id)"
              :key="p.id"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-body-2"
                    style="max-width: 500px"
                    v-text="`Сессия №${p.session_number}`"
                  />
                </v-list-item-content>
              </template>
              <v-list-item :key="p.id + item.kinescope_id">
                <v-simple-checkbox
                  :value="selected_products.includes(p)"
                  @input="
                    selected_products.includes(p)
                      ? doUnselectSession(p)
                      : doSelectSession(p)
                  "
                  color="primary"
                />
                <v-list-item-title class="text-body-2">
                  {{ p.session_number }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </div>
        <div
          v-else
          class="tree-node"
          :class="{
            'tree-node--branch': item.children.length !== 0,
            'tree-node--leaf': item.isEndNode,
            'tree-node--selected':
              item.isEndNode && selected_category === item.id,
          }"
          @click.stop="
            item.isEndNode &&
              (selected_category === item.id
                ? unselectCategory()
                : selectCategory(item.id))
          "
        >
          <span class="category-name">{{ item.name }}</span>
          <v-icon
            v-if="item.isEndNode"
            class="tree-node__check"
            :color="
              selected_category === item.id ? 'teal darken-1' : 'grey lighten-1'
            "
          >
            {{
              selected_category === item.id
                ? "mdi-checkbox-marked-circle"
                : "mdi-checkbox-blank-circle-outline"
            }}
          </v-icon>
        </div>
      </template>
    </v-treeview>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { CATEGORIES } from "@/utils/constants";

export default {
  name: "ProductsTreeView",
  components: {},
  props: {
    selectedCategory: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    const sortTree = (nodes) =>
      nodes
        .map((node) => ({
          ...node,
          children:
            node.children && node.children.length
              ? sortTree(node.children)
              : node.children,
        }))
        .sort((a, b) => {
          const aIsFolder = a.children && a.children.length > 0;
          const bIsFolder = b.children && b.children.length > 0;
          if (aIsFolder === bIsFolder) return 0;
          return aIsFolder ? -1 : 1;
        });

    return {
      selected_category: null,
      renderedNodes: [],
      categories: sortTree(JSON.parse(JSON.stringify(CATEGORIES))),
    };
  },
  watch: {
    selectedCategory: {
      handler(newVal) {
        this.selected_category = newVal;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("products", ["products"]),
  },
  methods: {
    addProductsToCategory(category) {
      // Фильтрация по id категории и сортировка по номеру сессии
      const allProducts = this.products
        .filter((product) => product.category_id === category.id)
        .sort((a, b) => a.session_number - b.session_number);

      // Добавляем все продукты напрямую в категорию
      category.children = allProducts;
    },
    renderTreeNode(openedNodes) {
      // Рендер только впервые открытых категорий
      if (
        openedNodes.length > 0 &&
        !this.renderedNodes.includes(openedNodes[openedNodes.length - 1])
      ) {
        this.renderedNodes.push(openedNodes[openedNodes.length - 1]);
      } else {
        return;
      }

      // Поиск открытой категории по её id
      function findItemById(categories, id) {
        for (const category of categories) {
          if (category.id === id) {
            return category;
          }
          if (category.children) {
            const found = findItemById(category.children, id);
            if (found) {
              return found;
            }
          }
        }
      }
      const openedItem = findItemById(
        this.categories,
        openedNodes[openedNodes.length - 1]
      );

      openedItem.children.forEach((child) => {
        if (child.children.length === 0) {
          child.isEndNode = true;
        }
      });
    },
    selectCategory(categoryId) {
      this.selected_category = categoryId;
      this.$emit("update:selectedCategory", this.selected_category);
    },
    unselectCategory() {
      this.selected_category = null;
      this.$emit("update:selectedCategory", this.selected_category);
    },
  },
};
</script>

<style scoped lang="scss">
.v-treeview {
  width: auto;
}

.category-name {
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.3;
  font-size: 13px;
}

.tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 4px 6px 4px 0;
  border-radius: 8px;
  transition: background 0.15s;

  &--branch {
    font-weight: 600;
    font-size: 13px;
    color: #2d5a52;
    padding-left: 0;
    cursor: default;
  }

  &--leaf {
    cursor: pointer;
    padding: 6px 8px;
    margin: 1px 0;

    &:hover {
      background: #f0f8f6;
    }

    .category-name {
      color: #333;
    }
  }

  &--selected {
    background: #e6f4f1 !important;

    .category-name {
      color: #1a6b5a;
      font-weight: 500;
    }
  }

  &__check {
    flex-shrink: 0;
    margin-left: 8px;
  }
}

@import "~vuetify/src/styles/styles.sass";

@media #{map-get($display-breakpoints, 'xs-only')} {
  .v-card #tree {
    overflow-x: scroll;
  }
}
</style>

<style lang="scss">
.v-list-group__header__append-icon {
  order: -1;
  margin-left: -25px !important;
  margin-right: 5px !important;
}
</style>
